
export class ToolRebuildOption {
  constructor(
    public hash?: string,
    public rebuildToolPublicHash?: string,
    public rebuildToolPublicName?: string,
    public rebuildOrder?: number,
  ) { }

  clone() {
    return new ToolRebuildOption (
      this.hash,
      this.rebuildToolPublicHash,
      this.rebuildToolPublicName,
      this.rebuildOrder
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-rebuild-option.ts